import { fromVariables } from 'convert-to-jcamp';
/**
 * Converts an analysis to an array of jcamp string. Each measurement will be in a different jcamp string
 * @param analysis
 * @param options
 * @returns array of jcamp strings
 */
export function toJcamps(analysis, options = {}) {
    const jcamps = [];
    for (const measurement of analysis.measurements) {
        jcamps.push(getJcamp(measurement, options));
    }
    return jcamps;
}
/**
 * @param measurement
 * @param options
 */
function getJcamp(measurement, options) {
    const { info = {}, meta = {} } = options;
    const jcampOptions = {
        options: {},
        info: {
            title: measurement.title,
            dataType: measurement.dataType,
            ...info,
        },
        meta: { ...measurement.meta, ...meta },
    };
    return fromVariables(measurement.variables, jcampOptions);
}
//# sourceMappingURL=toJcamps.js.map